module.exports = __webpack_public_path__ + "static/media/sample_counter.72d081ce.svg";